// extracted by mini-css-extract-plugin
export var bodyRow = "_gk-d";
export var cardColumns = "_gk-e";
export var ellipsesOverflow = "_gk-2";
export var flatBottomCorners = "_gk-3";
export var flatTopCorners = "_gk-4";
export var headerActionsDropdown = "_gk-f";
export var headerBottomRow = "_gk-c";
export var headerTopRow = "_gk-b";
export var orderDetailsWrapper = "_gk-0";
export var orderInfoContainer = "_gk-1";
export var productDetails = "_gk-9";
export var productImage = "_gk-5";
export var responsiveTable = "_gk-8";
export var shipmentContainer = "_gk-a";
export var tableBottomLeft = "_gk-6";
export var tableBottomRight = "_gk-7";